/**
 * CONTINAS CONTANTS LINKS
 */

const EVENT_NAMES = {
  FORM: {
    ENTITY_STATE_UPDATE:   'form-entities-state-update',
    ENTITY_UPDATE: 'form-entities-update',
    ENTITY_UPDATE_SUCCESS: 'form-entities-update-success',
    ENTITY_ERROR:  'form-entities-error',
  },
  AUTH: {
    LOGIN_PROCEED:        'auth-login-proceed',
    LOGIN_SUCCESS:        'auth-login-success',
    LOGIN_SUCCESS_AFTER:  'auth-login-success-after',
    LOGIN_FAIL:           'auth-login-fail',
    LOGOUT_PROCEED:       'auth-logout-proceed',
    LOGOUT_SUCCESS:       'auth-logout-success',
    LOGOUT_SUCCESS_AFTER: 'auth-logout-success-after',
    LOGOUT_FAIL:          'auth-logout-fail',
    REGISTER_PROCEED:     'auth-register-proceed',
    REGISTER_SUCCESS:     'auth-register-success',
    REGISTER_FAIL:        'auth-register-fail',
    SESSION_WATCH:        'auth-session-watch',
    SESSION_PROCEED:      'auth-session-proceed',
    SESSION_SUCCESS:      'auth-session-success',
    SESSION_FAIL:         'auth-session-fail',
  },
  LOCK: {
    LOGIN_PROCEED:       'lock-login-proceed',
    LOGIN_SUCCESS:       'lock-login-success',
    LOGIN_SUCCESS_AFTER: 'lock-login-success-after',
    LOGIN_FAIL:          'lock-login-fail',
  },
  USER: {
    DETAIL_PROCEED: 'user-detail-proceed',
    DETAIL_SUCCESS: 'user-detail-success',
    DETAIL_FAIL:    'user-detail-fail',
  },
  SPORTS: {
    EVENT_LISTS_PROCEED:  'sports-event-lists-proceed',
    EVENT_LISTS_SUCCESS:  'sports-event-lists-success',
    EVENT_LISTS_FAIL:     'sports-event-lists-fail',
  },
  ALERT: {
    INFO_DISPLAY:     'alert-info-display',
    INFO_SUCCESS:     'alert-info-success',
    INFO_FAIL:        'alert-info-fail',
    SUCCESS_DISPLAY:  'alert-success-display',
    SUCCESS_SUCCESS:  'alert-success-success',
    SUCCESS_FAIL:     'alert-success-fail',
    ERROR_DISPLAY:    'alert-error-display',
    ERROR_SUCCESS:    'alert-error-success',
    ERROR_FAIL:       'alert-error-fail',
    WARNING_DISPLAY:  'alert-warning-display',
    WARNING_SUCCESS:  'alert-warning-success',
    WARNING_FAIL:     'alert-warning-fail',
    QUESTION_DISPLAY: 'alert-question-display',
    QUESTION_SUCCESS: 'alert-question-success',
    QUESTION_FAIL:    'alert-question-fail',
    LOADING_DISPLAY:  'alert-loading-display',
    LOADING_STOP:     'alert-loading-stop',
    LOADING_SUCCESS:  'alert-loading-success',
    LOADING_FAIL:     'alert-loading-fail',
  },
  BETS: {
    BETSLIP_DISPLAY:           'bets-betslip-display',
    BETSLIP_UPDATE:            'bets-betslip-update',
    BETSLIP_SUCCESS:           'bets-betslip-success',
    BETSLIP_FAIL:              'bets-betslip-fail',
    BET_TIPS_ADD:              'bets-bet-tips-add',
    BET_TIPS_UPDATE:           'bets-bet-tips-update',
    BET_TIPS_REMOVE:           'bets-bet-tips-remove',
    BET_PLACE_PROCEED:         'bets-bet-place-proceed',
    BET_PLACE_SUCCESS:         'bets-bet-place-success',
    BET_PLACE_FAIL:            'bets-bet-place-fail',
    PREPAID_BET_PLACE_PROCEED: 'bets-prepaid-bet-place-proceed',
    PREPAID_BET_PLACE_SUCCESS: 'bets-prepaid-bet-place-success',
    PREPAID_BET_PLACE_FAIL:    'bets-prepaid-bet-place-fail',
  },
  PLAYER_TICKETS: {
    LIST_PROCEED:   'player-tickets-list-proceed',
    LIST_SUCCESS:   'player-tickets-list-success',
    LIST_FAIL:      'player-tickets-list-fail',
    READ_PROCEED:   'player-tickets-read-proceed',
    READ_SUCCESS:   'player-tickets-read-success',
    READ_FAIL:      'player-tickets-read-fail',
  },
  VIRTUAL_SPORTS_WEB: {
    SESSION_OPEN_PROCEED:   'virtual-sports-web-session-open-proceed',
    SESSION_OPEN_SUCCESS:   'virtual-sports-web-session-open-success',
    SESSION_OPEN_FAIL:      'virtual-sports-web-session-open-fail',
  },
  CASINO_WEB: {
    SESSION_OPEN_PROCEED:   'casino-web-session-open-proceed',
    SESSION_OPEN_SUCCESS:   'casino-web-session-open-success',
    SESSION_OPEN_FAIL:      'casino-web-session-open-fail',
  },
  POKER_WEB: {
    SESSION_OPEN_PROCEED:   'poker-web-session-open-proceed',
    SESSION_OPEN_SUCCESS:   'poker-web-session-open-success',
    SESSION_OPEN_FAIL:      'poker-web-session-open-fail',
  },
  VIRTUAL_SPORTS_CLIENT: {
    DEVICE_INFO: {
      READ_PROCEED:       'virtual-sports-client-device-info-read-proceed',
      READ_SUCCESS:       'virtual-sports-client-device-info-read-success',
      READ_SUCCESS_AFTER: 'virtual-sports-client-device-info-read-success-after',
      READ_FAIL:          'virtual-sports-client-device-info-read-fail',
    }
  },
  PLATFORM: {
    SESSIONS: {
      START_PROCEED:       'platform-sessions-start-proceed',
      START_SUCCESS:       'platform-sessions-start-success',
      START_SUCCESS_AFTER: 'platform-sessions-start-success-after',
      START_FAIL:          'platform-sessions-start-fail',
      TOKEN_PROCEED:       'platform-sessions-token-proceed',
      TOKEN_SUCCESS:       'platform-sessions-token-success',
      TOKEN_SUCCESS_AFTER: 'platform-sessions-token-success-after',
      TOKEN_FAIL:          'platform-sessions-token-fail',
      CSRF_PROCEED:        'platform-sessions-csrf-proceed',
      CSRF_SUCCESS:        'platform-sessions-csrf-success',
      CSRF_SUCCESS_AFTER:  'platform-sessions-csrf-success-after',
      CSRF_FAIL:           'platform-sessions-csrf-fail',
      CSRF_WATCH:          'platform-sessions-csrf-watch',
      CLOSE_PROCEED:       'platform-sessions-close-proceed',
      CLOSE_SUCCESS:       'platform-sessions-close-success',
      CLOSE_SUCCESS_AFTER: 'platform-sessions-close-success-after',
      CLOSE_FAIL:          'platform-sessions-close-fail',
    },
    SESSIONS_PREPAID: {
      READ_PROCEED:         'platform-sessions-prepaid-read-proceed',
      READ_SUCCESS:         'platform-sessions-prepaid-read-success',
      READ_SUCCESS_AFTER:   'platform-sessions-prepaid-read-success-after',
      READ_FAIL:            'platform-sessions-prepaid-read-fail',
      CREATE_PROCEED:       'platform-sessions-prepaid-create-proceed',
      CREATE_SUCCESS:       'platform-sessions-prepaid-create-success',
      CREATE_SUCCESS_AFTER: 'platform-sessions-prepaid-create-success-after',
      CREATE_FAIL:          'platform-sessions-prepaid-create-fail',
      DELETE_PROCEED:       'platform-sessions-prepaid-delete-proceed',
      DELETE_SUCCESS:       'platform-sessions-prepaid-delete-success',
      DELETE_SUCCESS_AFTER: 'platform-sessions-prepaid-delete-success-after',
      DELETE_FAIL:          'platform-sessions-prepaid-delete-fail',
    },
    WALLETS: {
      PAY_PROCEED:       'platform-sessions-pay-proceed',
      PAY_SUCCESS:       'platform-sessions-pay-success',
      PAY_SUCCESS_AFTER: 'platform-sessions-pay-success-after',
      PAY_FAIL:          'platform-sessions-pay-fail',
    }
  }
};

export default EVENT_NAMES;